var _react_refresh_temp_1, _react_refresh_temp_2, _react_refresh_temp_3, _react_refresh_temp_4, _react_refresh_temp_5;
var _react_refresh_temp_6;
_react_refresh_temp_6 = $RefreshSig$();
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React, { useCallback, useEffect, useState } from 'react';
import { createSelector } from '@reduxjs/toolkit';
import sanitizeHtml from 'sanitize-html';
import { isEmpty } from 'validator';
import { useTranslation } from 'react-i18next';
import { store, useAppSelector } from '../../../store';
import { isSocketConnected, sendWebsocketMessage, } from '../../../helpers/websocket';
import FileSend from './fileSend';
import { DataMessage, DataMsgBodyType, DataMsgType, } from '../../../helpers/proto/plugnmeet_datamessage_pb';
const isChatServiceReadySelector = createSelector(_react_refresh_temp_1 = (state) => state.session, (session) => session.isChatServiceReady);
$RefreshReg$(_react_refresh_temp_1, "isChatServiceReadySelector$createSelector");
const isLockChatSendMsgSelector = createSelector(_react_refresh_temp_2 = (state) => { var _a, _b; return (_b = (_a = state.session.currentUser) === null || _a === void 0 ? void 0 : _a.metadata) === null || _b === void 0 ? void 0 : _b.lock_settings; }, (lock_settings) => lock_settings === null || lock_settings === void 0 ? void 0 : lock_settings.lock_chat_send_message);
$RefreshReg$(_react_refresh_temp_2, "isLockChatSendMsgSelector$createSelector");
const isLockSendFileSelector = createSelector(_react_refresh_temp_3 = (state) => { var _a, _b; return (_b = (_a = state.session.currentUser) === null || _a === void 0 ? void 0 : _a.metadata) === null || _b === void 0 ? void 0 : _b.lock_settings; }, (lock_settings) => lock_settings === null || lock_settings === void 0 ? void 0 : lock_settings.lock_chat_file_share);
$RefreshReg$(_react_refresh_temp_3, "isLockSendFileSelector$createSelector");
const selectedChatOptionSelector = createSelector(_react_refresh_temp_4 = (state) => state.roomSettings, (roomSettings) => roomSettings.selectedChatOption);
$RefreshReg$(_react_refresh_temp_4, "selectedChatOptionSelector$createSelector");
const TextBoxArea = ({ currentRoom, chosenEmoji, onAfterSendMessage, }) => {
    _react_refresh_temp_6();
    const isChatServiceReady = useAppSelector(isChatServiceReadySelector);
    const isLockChatSendMsg = useAppSelector(isLockChatSendMsgSelector);
    const isLockSendFile = useAppSelector(isLockSendFileSelector);
    const selectedChatOption = useAppSelector(selectedChatOptionSelector);
    const { t } = useTranslation();
    const [lockSendMsg, setLockSendMsg] = useState(false);
    const [lockSendFile, setLockSendFile] = useState(false);
    const [showSendFile, setShowSendFile] = useState(true);
    const [message, setMessage] = useState('');
    useEffect(() => {
        const metadata = store.getState().session.currentRoom
            .metadata;
        if (!metadata.room_features.chat_features.allow_file_upload) {
            setShowSendFile(false);
        }
    }, []);
    useEffect(() => {
        if (isLockChatSendMsg) {
            setLockSendMsg(true);
        }
        else {
            setLockSendMsg(false);
        }
        if (isLockSendFile) {
            setLockSendFile(true);
        }
        else {
            setLockSendFile(false);
        }
    }, [isLockChatSendMsg, isLockSendFile]);
    // default room lock settings
    useEffect(() => {
        var _a, _b, _c, _d, _e, _f;
        const lock_chat_send_message = (_b = (_a = store.getState().session.currentRoom.metadata) === null || _a === void 0 ? void 0 : _a.default_lock_settings) === null || _b === void 0 ? void 0 : _b.lock_chat_send_message;
        const lock_chat_file_share = (_d = (_c = store.getState().session.currentRoom.metadata) === null || _c === void 0 ? void 0 : _c.default_lock_settings) === null || _d === void 0 ? void 0 : _d.lock_chat_file_share;
        const isAdmin = (_f = (_e = store.getState().session.currentUser) === null || _e === void 0 ? void 0 : _e.metadata) === null || _f === void 0 ? void 0 : _f.is_admin;
        if (lock_chat_send_message && !isAdmin) {
            if (isLockChatSendMsg !== false) {
                setLockSendMsg(true);
            }
        }
        if (lock_chat_file_share && !isAdmin) {
            if (isLockChatSendMsg !== false) {
                setLockSendFile(true);
            }
        }
    }, []);
    const addEmoji = useCallback((emoji) => {
        const msg = message + emoji;
        setMessage(msg);
    }, [message]);
    useEffect(() => {
        if (chosenEmoji) {
            addEmoji(chosenEmoji);
        }
    }, [chosenEmoji]);
    const cleanHtml = (rawText) => {
        return sanitizeHtml(rawText, {
            allowedTags: ['b', 'i', 'strong', 'br'],
            allowedSchemes: ['mailto', 'tel'],
        });
    };
    const sendMsg = async () => {
        const msg = cleanHtml(message);
        if (isEmpty(msg)) {
            return;
        }
        const dataMsg = new DataMessage({
            type: DataMsgType.USER,
            roomSid: currentRoom.sid,
            roomId: currentRoom.name,
            to: selectedChatOption !== 'public' ? selectedChatOption : '',
            body: {
                type: DataMsgBodyType.CHAT,
                isPrivate: selectedChatOption !== 'public' ? 1 : 0,
                from: {
                    sid: currentRoom.localParticipant.sid,
                    userId: currentRoom.localParticipant.identity,
                    name: currentRoom.localParticipant.name,
                },
                msg: msg.replace(/\r?\n/g, '<br />'),
            },
        });
        if (isSocketConnected()) {
            sendWebsocketMessage(dataMsg.toBinary());
            setMessage('');
        }
        onAfterSendMessage();
    };
    const onEnterPress = (e) => {
        if (e.keyCode == 13 && e.shiftKey == false) {
            e.preventDefault();
            sendMsg();
        }
    };
    return (_jsx(_Fragment, { children: _jsxs("div", { className: "flex items-start justify-between h-[4.5rem] p-2 pl-10 md:pl-0", children: [_jsx("textarea", { name: "message-textarea", id: "message-textarea", className: "w-full bg-white dark:bg-darkSecondary2 h-14 max-h-14 mt-1 leading-[1.2] rounded-xl py-2 px-4 outline-none text-xs lg:text-sm primaryColor dark:text-white placeholder:text-primaryColor/70 dark:placeholder:text-white/70", value: message, onChange: (e) => setMessage(e.currentTarget.value), disabled: !isChatServiceReady || lockSendMsg, placeholder: t('right-panel.chat-box-placeholder').toString(), onKeyDown: (e) => onEnterPress(e) }), _jsxs("div", { className: "btns", children: [_jsx("button", { disabled: !isChatServiceReady || lockSendMsg, onClick: () => sendMsg(), className: "w-4 h-6 p-2", children: _jsx("i", { className: "pnm-send primaryColor text-[20px] dark:text-secondaryColor" }) }), showSendFile ? (_jsx(FileSend, { isChatServiceReady: isChatServiceReady, lockSendFile: lockSendFile, currentRoom: currentRoom })) : null] })] }) }));
};
_react_refresh_temp_5 = TextBoxArea;
$RefreshReg$(_react_refresh_temp_5, "TextBoxArea");
_react_refresh_temp_6(TextBoxArea, "Yzs7CUP+0gfUbt5XNIxTSxENbGY=", false, () => [useAppSelector, useAppSelector, useAppSelector, useAppSelector, useTranslation]);
export default TextBoxArea;
